export default "__VITE_ASSET__B9gL4wL1__"